/**
 * @requirement S-041 AC #2 — "Drop-zone is primary CTA (visually
 *   dominant); provider menu is secondary (in app-bar)".
 *
 * Secondary provider picker rendered in the app-bar (not the hero).
 * MVP shows only "Open from device" (delegates to the caller's
 * picker handler). Cloud providers (Drive, Dropbox, OneDrive)
 * appear as disabled items with a "Sign in" affordance planned for
 * S-050+ signed-in flow.
 */

import { Button } from '../../ui/primitives/Button';

import type { ReactElement } from 'react';

export interface ProviderMenuProps {
  onOpenLocal: () => void;
}

export function ProviderMenu({ onOpenLocal }: ProviderMenuProps): ReactElement {
  return (
    <nav aria-label="Open a document" className="flex items-center gap-2">
      <Button variant="ghost" onClick={onOpenLocal}>
        Open from device
      </Button>
      <span
        className="text-xs text-chrome-text-secondary"
        aria-label="Cloud providers pending sign-in"
      >
        Drive · Dropbox · OneDrive (soon)
      </span>
    </nav>
  );
}
